export const interestRateHigh = 10.2;
export const interestRateLow = 7.3;
export const inflationRate = 3.2;
export const anuityRate = 4.5;
export const savingPresets = [100, 250, 500, 1000];
export const balancePresets = [0, 10000, 40000, 100000];
